export const hasKey = (obj: unknown, key: string): boolean => {
  return typeof obj === 'object' && obj !== null && key in obj;
};
